import { lazy } from 'react'
import IconPingguduixiangfenxi from '@/components/iconfont/IconPingguduixiangfenxi'
import IconPinggugongzuokaizhanqingkuang from '@/components/iconfont/IconPinggugongzuokaizhanqingkuang'


const menu = [
  {
    path: '/home/report-form/assess-situation',
    component: lazy(() => import('@/views/Home/ReportForm/AssessSituation/AssessSituation')),
    exact: false,
    meta: {
      key: 'assess-situation',
      title: '评估工作开展情况',
      icon: <IconPingguduixiangfenxi color="rgba(225, 225, 225, .75)"></IconPingguduixiangfenxi>,
      requireAuth: false
    }
  },
  {
    meta: {
      title: '评估对象分析',
      requireAuth: false,
      subMenu: true,
      icon: <IconPinggugongzuokaizhanqingkuang color="rgba(225, 225, 225, .75)"></IconPinggugongzuokaizhanqingkuang>,
    },
    children: [
      {
        path: '/home/report-form/assess-object-sex',
        component: lazy(() => import('@/views/Home/ReportForm/AssessObjectSex/AssessObjectSex')),
        exact: false,
        meta: {
          key: 'assess-object-sex',
          title: '年龄及性别分布',
          requireAuth: false
        }
      },
      // {
      //   path: '/home/report-form/assess-object-disease',
      //   component: lazy(() => import('@/views/Home/ReportForm/AssessObjectDisease/AssessObjectDisease')),
      //   exact: false,
      //   meta: {
      //     key: 'assess-object-disease',
      //     title: '共病分布情况',
      //     requireAuth: false
      //   }
      // },
      {
        path: '/home/report-form/assess-object-drug',
        component: lazy(() => import('@/views/Home/ReportForm/AssessObjectDrug/AssessObjectDrug')),
        exact: false,
        meta: {
          key: 'assess-object-drug',
          title: '用药分布情况',
          requireAuth: false
        }
      },
      {
        path: '/home/report-form/assess-object-level',
        component: lazy(() => import('@/views/Home/ReportForm/AssessObjectLevel/AssessObjectLevel')),
        exact: false,
        meta: {
          key: 'assess-object-level',
          title: '能力等级状况',
          requireAuth: false
        }
      },
      {
        path: '/home/report-form/assess-object-syndrome',
        component: lazy(() => import('@/views/Home/ReportForm/AssessObjectSyndrome/AssessObjectSyndrome')),
        exact: false,
        meta: {
          key: 'assess-object-syndrome',
          title: '综合征罹患分析',
          requireAuth: false
        }
      },
    ]
  },
  // {
  //   path: '/home/report-form/assess-quality',
  //   component: lazy(() => import('@/views/Home/ReportForm/AssessQuality/AssessQuality')),
  //   exact: false,
  //   meta: {
  //     key: 'assess-quality',
  //     title: '评估质量分析',
  //     icon: '',
  //     requireAuth: false
  //   }
  // }
]

export default menu